'use client';

import styled from 'styled-components';

import { Box, Flex, Modal, Spacing } from '@zoomit/primitives';
import type { BuyingGuideResponseItem } from '@zoomit/web-kit';
import {
  Anchor,
  Button,
  cssVar,
  ModalActions,
  ModalHead,
  RedDot,
  theme,
  Typography,
} from '@zoomit/zoomit-ds';

type Props = {
  onClose: () => void;
  categorySlug: string;
  items: BuyingGuideResponseItem[];
};

const BuyingGuideDetailsPopup = (props: Props) => {
  const { onClose, items, categorySlug } = props;

  return (
    <Modal size="md" onClose={onClose}>
      <ModalHead title="راهنماهای خریدی که این محصول در آن‌ها پیشنهاد شده" onClose={onClose}></ModalHead>
      <Box
        className="h-[470px] overflow-y-auto"
        backgroundColor={cssVar(theme.background2)}
        spacing={{ pt: 'x4', px: 'x6' }}
      >
        <Typography tag="p" fontSize={1.4} lineHeight={2} textColor={cssVar(theme.grey1)}>
          با انتخاب هر راهنمای خرید، لیست کاملی از محصولات پیشنهادی زوبین را مشاهده کنید.
        </Typography>
        <Flex spacing={{ mt: 'x4' }} flexDirection="column" gap={Spacing.x2}>
          {items.map(({ id, title, defaultSort }) => (
            <BuyingGuideAnchor
              key={id}
              href={`/list/${categorySlug}?buyingGuideIds=${id}&sort=${defaultSort}`}
              className="fa"
            >
              <RedDot />
              <Typography fontSize={1.6} fontWeight={900} lineHeight={1.75}>
                {title}
              </Typography>
            </BuyingGuideAnchor>
          ))}
        </Flex>
      </Box>
      <ModalActions>
        <Button variant="outline" size="auto" spacing={{ py: 'x2', px: 'x5' }} onClick={onClose}>
          بستن
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default BuyingGuideDetailsPopup;

const BuyingGuideAnchor = styled(Anchor)`
  display: flex;
  justify-content: flex-start;
  padding: ${Spacing.x2}rem ${Spacing.x4}rem;
  width: 100%;
  flex: 1;
  border-radius: var(${theme.radius.md});
  border: solid 1px var(${theme.grey6});
`;
